import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "child-comment-container" }
const _hoisted_2 = {
  key: 0,
  class: "loading"
}
const _hoisted_3 = {
  key: 1,
  class: "child-comments-wrapper"
}
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "comment-content" }
const _hoisted_6 = { class: "comment-header" }
const _hoisted_7 = { class: "comment-time" }
const _hoisted_8 = { class: "comment-actions" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "pagination-container" }
const _hoisted_13 = {
  key: 2,
  class: "no-child-comments"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "加载评论中..."))
      : (_ctx.childComments && _ctx.childComments.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childComments, (comment) => {
              return (_openBlock(), _createElementBlock("div", {
                key: comment.id,
                class: "child-comment-item"
              }, [
                _createElementVNode("img", {
                  src: comment.userAvatar,
                  alt: comment.name,
                  class: "comment-avatar"
                }, null, 8, _hoisted_4),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("strong", null, _toDisplayString(comment.name), 1),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formatDate(comment.createTime)), 1)
                  ]),
                  _createElementVNode("p", null, _toDisplayString(comment.content), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.toggleCommentLike(comment)),
                      class: _normalizeClass(['comment-like-btn', { liked: comment.isLiked === 1 }])
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(comment.isLiked === 1 ? 'icon-child-comment-liked' : 'icon-child-comment-like')
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(comment.likeCount), 1)
                    ], 10, _hoisted_9),
                    (_ctx.currentUser.id === comment.userId)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _withModifiers(($event: any) => (_ctx.deleteCurrentComment(comment)), ["stop"]),
                          class: "comment-delete-btn"
                        }, [...(_cache[1] || (_cache[1] = [
                          _createElementVNode("i", { class: "icon-delete" }, null, -1),
                          _createTextVNode(" 删除 ", -1)
                        ]))], 8, _hoisted_10))
                      : _createCommentVNode("", true),
                    (_ctx.currentUser.id !== comment.userId)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "comment-report-btn",
                          onClick: ($event: any) => (_ctx.openCommentReportDialog(comment.id))
                        }, [...(_cache[2] || (_cache[2] = [
                          _createElementVNode("i", { class: "icon-report" }, "举报", -1)
                        ]))], 8, _hoisted_11))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_el_pagination, {
                "current-page": _ctx.currentPage,
                "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
                "page-size": _ctx.pageSize,
                total: _ctx.total,
                layout: "prev, pager, next",
                onCurrentChange: _ctx.handlePageChange,
                "hide-on-single-page": false,
                "pager-count": 5
              }, null, 8, ["current-page", "page-size", "total", "onCurrentChange"])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, "暂无回复"))
  ]))
}